/* models/selections/index */ function _(require, module, exports) {
    var tslib_1 = require(426) /* tslib */;
    tslib_1.__exportStar(require(208) /* ./interaction_policy */, exports);
    var selection_1 = require(209) /* ./selection */;
    exports.Selection = selection_1.Selection;
}
